import { observer } from 'mobx-react-lite'
import { useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import { Button, toastStore } from 'shared/ui'
import { AudioPlayer } from 'shared/ui/AudioPlayer'
import { logger } from 'shared/lib'
import { sentEventSentry } from 'entities/Sentry'
import { useTextToSpeechContext } from 'widgets/TextToSpeech/context/context'
import styles from './styles.module.scss'

export const PlaySpeechBtn = observer(() => {
  const { loadAudioSpeech, isDisabledPreview, audioSpeechSrc, audioFileDuration, textKey } =
    useTextToSpeechContext()

  const loadingKey = useRef('')
  const [loading, setLoading] = useState(false)
  const [playing, setPlaying] = useState(false)

  const handlePlay = async () => {
    try {
      setLoading(true)
      loadingKey.current = textKey
      await loadAudioSpeech()
      if (loadingKey.current === textKey) {
        setPlaying(true)
      }
    } catch (e) {
      toastStore.add({
        type: 'error',
        title: 'Something went wrong!',
      })
      logger.error(e)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    loadingKey.current = ''
    setLoading(false)
    setPlaying(false)
  }, [textKey])

  const togglePlaying = (value: boolean) => {
    if (!value) {
      setPlaying(false)
    }
  }

  return (
    <div className={styles.wrap}>
      {loading && (
        <Button
          icon={'play'}
          iconProps={{
            className: styles.icon,
            disabled: true,
          }}
          iconClassName={styles.wrapIcon}
          size={'small'}
          contained={'secondary'}
          text={'Generating audio...'}
          className={styles.disabled}
        />
      )}
      {!loading &&
        (playing ? (
          <AudioPlayer
            url={audioSpeechSrc}
            duration={audioFileDuration}
            widthWave={140}
            size={'small'}
            colorType={'gray'}
            noRightActions
            autoplay
            togglePlaying={togglePlaying}
            className={styles.player}
            onError={(error) => {
              sentEventSentry({
                event: '[Audio] PlaySpeechBtn - error',
                name: 'audio:error',
                level: 'error',
                error: error,
              })
            }}
          />
        ) : (
          <Button
            icon={'play'}
            iconProps={{
              className: styles.icon,
              disabled: isDisabledPreview,
            }}
            iconClassName={styles.wrapIcon}
            size={'small'}
            contained={'secondary'}
            onClick={handlePlay}
            text={'Play'}
            className={classNames(isDisabledPreview && styles.disabled)}
          />
        ))}
    </div>
  )
})
